import { render, staticRenderFns } from "./triggerAnchor.vue?vue&type=template&id=03589f25"
import script from "./triggerAnchor.vue?vue&type=script&lang=ts"
export * from "./triggerAnchor.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../soccer/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports